export const BrandTag = ({ size = "sm", compact = false, className = "" }) => {
  const font = size === "md" ? "1.05rem" : "0.92rem";
  const w = size === "md" ? 22 : 18;
  const h = size === "md" ? 13 : 11;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid="provider-brand-tag">
      {!compact && (
        <svg width={w} height={h} viewBox="0 0 40 24" fill="none" aria-hidden="true">
          <path d="M1 9 Q 6 2 11 9 T 21 9 T 31 9 T 39 9" stroke="#c85a32" strokeWidth="3" strokeLinecap="round" fill="none" />
          <path d="M1 15 Q 6 22 11 15 T 21 15 T 31 15 T 39 15" stroke="#8ab48a" strokeWidth="3" strokeLinecap="round" fill="none" />
        </svg>
      )}
      <span className="font-display font-semibold leading-none tracking-tight text-petrol" style={{ fontSize: font }}>
        best<span className="text-terracotta">price</span>
        {!compact && <span style={{ opacity: 0.55 }}>·umago</span>}
      </span>
    </span>
  );
};
